import React, { useRef, useEffect } from "react";
import { Link } from "react-router-dom";
import sal from "sal.js";
import "swiper/css";
import "swiper/css/navigation";
import SponserSlider from "../../Components/SponserSlider";
import AboutUsSwiperSlider from"../../Components/AboutUsSwiperSlider";
import { Helmet } from "@dr.pogodin/react-helmet";

function About() {
  useEffect(() => {
    sal();
  }, []);
  return (
    <>

    <div className="container">
      <Helmet>
        <title>About Us - Infinitivehost</title>
        <meta name="description" content="Infinitive Host started in 2017 with the aim of providing better hosting services to clients. We have designed customized and affordable web hosting plans for our clients." />
        <meta name="keywords" content="about us, company history, mission statement, team, values, company profile, our story, company vision, who we are, about our company" />
        <meta property="og:url" content={`${import.meta.env.VITE_FRONTEND_URL}/about-us`} />
        <link rel="canonical" href={`${import.meta.env.VITE_FRONTEND_WWW_URL}/about-us`} />
        <meta property="og:title" content="Secure & Affordable Hosting Platform For Your Needs" />
        <meta property="og:description" content="Infinitive Host started in 2017 with the aim of providing better hosting services to clients. We have designed customized and affordable web hosting plans for our clients." />
      </Helmet>
    </div>

    <div className="pt-100 pb-100 bg-dark">
        <div className="container">
            <div className="row g-4 align-items-center align-items-xxl-end">
                <div className="col-lg-7">
                    <div className="d-flex align-items-center gap-2">
                        <div className="w-3 h-3 rounded-circle bg-primary flex-shrink-0"></div>
                        <span className="d-block fw-semibold mb-0 text-primary">
                            About Our Hosting Company
                        </span>
                    </div>
                    <h1 className="mb-6 text-white">
                        We believe there
                        is a better way to work
                        with technology
                    </h1>
                    <p className="text-white max-text-60 mb-8 text-opacity-75">
                        We specialize in providing high-bandwidth dedicated servers with unparalleled connectivity. Backed by a robust network, abundant server options, and a "we're here to cater to you" reliable service, you can truly count on us.
                    </p>
                    <div className="d-flex align-items-center flex-wrap gap-4">
                        <Link to="/contact-us" className="btn btn-primary btn-arrow btn-lg fs-14 fw-semibold rounded btn-height">
                            <span className="btn-arrow__text">
                                Sign up - Free Trial
                                <span className="btn-arrow__icon">
                                    <i className="fa-solid fa-arrow-right"></i>
                                </span>
                            </span>
                        </Link>
                        <Link to="/" className="btn btn-light btn-arrow btn-lg fs-14 fw-semibold rounded transition btn-height">
                            <span className="btn-arrow__text">
                                Explore Product
                                <span className="btn-arrow__icon">
                                    <i className="fa-solid fa-arrow-right"></i>
                                </span>
                            </span>
                        </Link>
                    </div>
                </div>
                <div className="col-lg-5 ipad-mt">
                    <div className="about-banner__img">
                        <img src="images/we-believe-there-is-better.webp" alt="image" className="img-fluid full-width-img" />
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div className="pt-120 pb-60">
        <div className="container">
            <div className="row g-4">
                <div className="col-lg-4 sal-animate text-center" data-sal="fade" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                    <figure className="img-frame">
                    <img src="images/kuldeep-negi.jpg" alt="imge" className="img-fluid"/>
                    </figure>
                </div>
                <div className="col-lg-8">
                    <h2 className="h5 d-inline-flex align-items-center gap-2 mb-4 text-primary sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                        <span className="d-inline-block">
                            Our Founder
                        </span>
                        <span className="d-inline-block w-15 h-1 bg-primary"></span>
                    </h2>
                    <p className="mb-6 fw-medium sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                        Kuldeep Negi founded InfinitiveHost in 2017, with the vision of providing the most trusted and reliable web hosting solutions while also solving the biggest issue in the web hosting industry of having strong technical support. His interest lies in building innovative products to solve customers’ core issues, building strong teams, and making strategic decisions.
                    </p>
                    <p className="mb-6 fw-medium sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                        With an exceptional focus on customer growth and future-proof technology, they transformed Infinitive Host into a brand that values unbeatable performance, high speed, trust, and people. Their leadership remains to inspire a culture of interest, excellence, and success-empowering organizations to move faster, scale smarter, and thrive in the digital world.
                    </p>

                </div>
            </div>
        </div>
    </div>

    
    <AboutUsSwiperSlider/>

    <section className="why-area-one bg-dark pt-100 pb-100 position-relative z-1">
            <div className="container">
                <div className="row align-items-center justify-content-between">
                    <div className="col-xl-7 col-lg-8">
                        <span className="section-title-dark style-bg fadeInUp">Choose Us</span>
                        <h2 className="text-white" data-sal="slide-up" data-sal-duration="500" data-sal-delay="200" data-sal-easing="ease-in-out-sine">Powerful & Secure: Web Hosting You Can’t Miss</h2>
                    </div>
                </div>
                <div className="mt-8">
                    <div className="row g-4">
                        <div className="col-xl-4 col-md-6" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                            <div className="why-card px-6 py-9 rounded-3 transition h-100">
                                <img src="images/hosting-that-always.webp" alt="image" className="img-fluid" />
                                <img src="images/hosting-that-always-dark.webp" alt="image" className="img-fluid dark" />
                                <h6 className="can-miss-title text-white mt-7">Hosting That Always Scales with You</h6>
                                <p className="text-white text-opacity-75 mb-0">Slow speed? Get high-speed servers, robust performance, constant support, and ideal scalability, which will constantly boost your growth.</p>
                            </div>
                        </div>
                        <div className="col-xl-4 col-md-6" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                            <div className="why-card px-6 py-9 rounded-3 transition h-100">
                                <img src="images/worldwide-level.webp" alt="image" className="img-fluid" />
                                <img src="images/worldwide-level-dark.webp" alt="image" className="img-fluid dark" />
                                <h6 className="can-miss-title text-white mt-7">Worldwide-Level Reach, Local Reliability</h6>
                                <p className="text-white text-opacity-75 mb-0">Strategic servers across the US, India, and Europe guarantee high uptime & high performance, keeping your site always up and seamlessly running.</p>
                            </div>
                        </div>
                        <div className="col-xl-4 col-md-6" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                            <div className="why-card px-6 py-9 rounded-3 transition h-100">
                                <img src="images/support-that’s-always.webp" alt="image" className="img-fluid" />
                                <img src="images/support-that’s-always-dark.webp" alt="image" className="img-fluid dark" />
                                <h6 className="can-miss-title text-white mt-7">Support That’s Always Have Your Back</h6>
                                <p className="text-white text-opacity-75 mb-0">Get professional guidance with 24/7 MS Teams support and many more-ensuring smooth GPU hosting, etc., and a hassle-free experience, anytime you want it.</p>
                            </div>
                        </div>
                        <div className="col-xl-4 col-md-6" data-sal="slide-up" data-sal-duration="500" data-sal-delay="500" data-sal-easing="ease-in-out-sine">
                            <div className="why-card px-6 py-9 rounded-3 transition h-100">
                                <img src="images/reliable-protection.webp" alt="image" className="img-fluid" />
                                <img src="images/reliable-protection-dark.webp" alt="image" className="img-fluid dark" />
                                <h6 className="can-miss-title text-white mt-7">Reliable Protection, Powerful Performance</h6>
                                <p className="text-white text-opacity-75 mb-0">Tier 4 data centers and cutting-edge security measures always keep your servers protected from all threats so that you can only focus on what truly matters.</p>
                            </div>
                        </div>
                        <div className="col-xl-4 col-md-6" data-sal="slide-up" data-sal-duration="500" data-sal-delay="500" data-sal-easing="ease-in-out-sine">
                            <div className="why-card px-6 py-9 rounded-3 transition h-100">
                                <img src="images/advanced-technology.webp" alt="image" className="img-fluid" />
                                <img src="images/advanced-technology-dark.webp" alt="image" className="img-fluid dark" />
                                <h6 className="can-miss-title text-white mt-7">Advanced Technology for High Speed</h6>
                                <p className="text-white text-opacity-75 mb-0">Powerful infrastructure guarantees 24/7 expert support, robust security, and 10x faster performance, keeping you in the lead of the competitive era.</p>
                            </div>
                        </div>
                        <div className="col-xl-4 col-md-6" data-sal="slide-up" data-sal-duration="500" data-sal-delay="500" data-sal-easing="ease-in-out-sine">
                            <div className="why-card px-6 py-9 rounded-3 transition h-100">
                                <img src="images/stress-free-migration.webp" alt="image" className="img-fluid" />
                                <img src="images/stress-free-migration-dark.webp" alt="image" className="img-fluid dark" />
                                <h6 className="can-miss-title text-white mt-7">Stress-Free Migration With No Downtime</h6>
                                <p className="text-white text-opacity-75 mb-0">Flawlessly move all your data with no downtime and no risk. Get a highly-secure data transfer & keep your site always running without interruption!</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="mt-20">
                    <div className="row g-4">
                        <div className="col-md-3 col-6">
                            <div className="why-service-item text-center position-relative" data-sal="slide-up" data-sal-duration="500" data-sal-delay="200" data-sal-easing="ease-in-out-sine">
                                <img className="about-us-img mb-3" src="images/6000-clients.webp" alt="" />
                                <h5 className="text-white mb-3"><span className="counter">6000+</span></h5>
                                <p className="text-white text-opacity-75">Clients</p>
                            </div>
                        </div>
                        <div className="col-md-3 col-6">
                            <div className="why-service-item text-center position-relative" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                                <img className="about-us-img mb-3" src="images/2017-established.webp" alt="" />
                                <h5 className="text-white mb-3"><span className="counter">2017</span></h5>
                                <p className="text-white text-opacity-75">Established</p>
                            </div>
                        </div>
                        <div className="col-md-3 col-6">
                            <div className="why-service-item text-center position-relative" data-sal="slide-up" data-sal-duration="500" data-sal-delay="400" data-sal-easing="ease-in-out-sine">
                                <img className="about-us-img mb-3" src="images/11-data-centers.webp" alt="" />
                                <h5 className="text-white mb-3"><span className="counter">11+</span></h5>
                                <p className="text-white text-opacity-75">Data Centers</p>
                            </div>
                        </div>
                        <div className="col-md-3 col-6">
                            <div className="why-service-item last text-center position-relative" data-sal="slide-up" data-sal-duration="500" data-sal-delay="400" data-sal-easing="ease-in-out-sine">
                                <img className="about-us-img mb-3" src="images/client-satisfaction.webp" alt="" />
                                <h5 className="text-white mb-3"><span className="counter">100%</span></h5>
                                <p className="text-white text-opacity-75">Client Satisfaction</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

    <section className="pt-60 pb-00 bg-secondary">
        <div className="container">
            <div className="pt-00">
                <div className="row align-items-center justify-content-between g-4">
                    <div className="col-lg-6">
                        <img src="images/server-about-3.png" alt="image" className="img-fluid sal-animate" data-sal="fade" data-sal-duration="1000" data-sal-delay="300" data-sal-easing="ease-in-out-sine" />
                    </div>
                    <div className="col-lg-6">
                        <h2 className="h4 mb-3 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">Who We Are</h2>
                        <p className="mb-3 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">The journey of InfinitiveHost starts from 2017 with a vision to solve customers’ problem of having a trusted and reliable hosting provider. The founder of the company Mr. Kuldeep Negi had realised that people were facing a big issue of having a trusted hosting provider with available technical support to resolve their server related issues. This motivated him to build a reliable and trusted web hosting platform that not only provides quality hosting solutions but also solves customers’ problems by providing 24/7 instant manual support.</p><br />
                        <p className="mb-0 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">Today InfinitiveHost is a leading name in the web hosting industry that provides hosting services in all domains, including shared, VPS, dedicated, application, Windows, cloud, email servers, and streaming solutions. All our web hosting plans are designed to meet the customized needs of our clients and also fit their pockets. Every day, we try to develop and do everything we can to make our clients’ aspirations a reality. Our customers can count on us to treat them with respect and humility.</p>
                    </div>
                </div>
            </div>
        </div>
    </section>

    <div className="container pt-100 pb-60">
        <div className="row g-4">
            <div className="col-12">
                <div className="card border-0 roudned-4">
                    <div className="card-body pt-60 pb-60 px-md-15">
                        <div className="row g-4 align-items-center justify-content-between">
                            <div className="col-lg-4 sal-animate" data-sal="fade" data-sal-duration="1000" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                                <div className="cloud-hero__img">
                                    <img src="images/partner-1.png" alt="image" className="img-fluid" />
                                </div>
                            </div>
                            <div className="col-lg-8 col-xl-7">
                                <span className="d-flex align-items-center gap-2 mb-2 sal-animate" data-sal="slide-up" data-sal-duration="1000" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                    <span className="d-block w-2 h-2 rounded-circle bg-success"></span>
                                <span className="d-block text-white">
                      <span className="text-success fw-medium">Included Features</span>
                                </span>
                                </span>
                                <h2 className="h3 mb-4 sal-animate" data-sal="slide-up" data-sal-duration="1000" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                                    We offer 
                                </h2>
                                <p className="mb-8 max-text-56 sal-animate" data-sal="slide-up" data-sal-duration="1000" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                                    We offer trusted and reliable web hosting solutions to each category of clients. Our hosting services includes: Shared server, reseller hosting, VPS, cloud, dedicated servers, managed services, enterprise email services, streaming services, Zimbra, and SSL. You will get these added premium features with our each service.
                                </p>
                                <div className="row g-3">
                                    <div className="col-md-6 sal-animate" data-sal="slide-up" data-sal-duration="1000" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                                        <div className="vstack gap-2">
                                            <div className="d-flex align-items-center gap-2">
                                                <div className="w-4 h-4 bg-success rounded-circle fs-12 text-white d-flex align-items-center justify-content-center">
                                                    <i className="fa-solid fa-check"></i>
                                                </div>
                                                <span className="d-block fw-medium fs-14">Free migration</span>
                                            </div>
                                            <div className="d-flex align-items-center gap-2">
                                                <div className="w-4 h-4 bg-success rounded-circle fs-12 text-white d-flex align-items-center justify-content-center">
                                                    <i className="fa-solid fa-check"></i>
                                                </div>
                                                <span className="d-block fw-medium fs-14">Free SSL Certificate </span>
                                            </div>
                                            <div className="d-flex align-items-center gap-2">
                                                <div className="w-4 h-4 bg-success rounded-circle fs-12 text-white d-flex align-items-center justify-content-center">
                                                    <i className="fa-solid fa-check"></i>
                                                </div>
                                                <span className="d-block fw-medium fs-14">24/7 manual server support</span>
                                            </div>
                                            <div className="d-flex align-items-center gap-2">
                                                <div className="w-4 h-4 bg-success rounded-circle fs-12 text-white d-flex align-items-center justify-content-center">
                                                    <i className="fa-solid fa-check"></i>
                                                </div>
                                                <span className="d-block fw-medium fs-14">99.9% uptime guarantee</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-6 sal-animate" data-sal="slide-up" data-sal-duration="1000" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                                        <div className="vstack gap-2">
                                            <div className="d-flex align-items-center gap-2">
                                                <div className="w-4 h-4 bg-success rounded-circle fs-12 text-white d-flex align-items-center justify-content-center">
                                                    <i className="fa-solid fa-check"></i>
                                                </div>
                                                <span className="d-block fw-medium fs-14">Instant Server Setup</span>
                                            </div>
                                            <div className="d-flex align-items-center gap-2">
                                                <div className="w-4 h-4 bg-success rounded-circle fs-12 text-white d-flex align-items-center justify-content-center">
                                                    <i className="fa-solid fa-check"></i>
                                                </div>
                                                <span className="d-block fw-medium fs-14">High-Performance Hardware</span>
                                            </div>
                                            <div className="d-flex align-items-center gap-2">
                                                <div className="w-4 h-4 bg-success rounded-circle fs-12 text-white d-flex align-items-center justify-content-center">
                                                    <i className="fa-solid fa-check"></i>
                                                </div>
                                                <span className="d-block fw-medium fs-14">Powered by NVMe SSDs</span>
                                            </div>
                                            <div className="d-flex align-items-center gap-2">
                                                <div className="w-4 h-4 bg-success rounded-circle fs-12 text-white d-flex align-items-center justify-content-center">
                                                    <i className="fa-solid fa-check"></i>
                                                </div>
                                                <span className="d-block fw-medium fs-14">Easy Configuration</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <Link to="/contact-us" className="btn btn-success btn-arrow btn-arrow-lg btn-lg fs-14 fw-semibold rounded-pill mt-8 sal-animate" data-sal="slide-up" data-sal-duration="1000" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                                    <span className="btn-arrow__text">
                      Explore More
                      <span className="btn-arrow__icon">
                        <i className="fa-solid fa-arrow-right"></i>
                      </span>
                                    </span>
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <section className="service-area pt-60 pb-100">
            <div className="pb-40">
                <div className="container">
                    <div className="row">
                        <div className="col-xl-7">
                            <h2 className="mb-0 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="200" data-sal-easing="ease-in-out-sine">What We Strive For?</h2>
                        </div>
                    </div>
                </div>
            </div>
            <div className="container">
                <div className="row g-4">
                    <div className="col-lg-6 col-md-6 col-xl-4">
                        <div className="card service-card-item shadow-sm rounded-3 h-100 sal-animate" data-sal="slide-up" data-sal-duration="400" data-sal-delay="100" data-sal-easing="ease-in-out-sine">
                            <div className="card-body px-md-7 py-md-8">
                                <h6>Our Goals</h6>
                                <div className="d-flex gap-5 flex-wrap flex-sm-nowrap mt-6">
                                    <div>
                                        <img src="images/service-icon-1.png" alt="" />
                                    </div>
                                    <div>
                                        <p>Our goal is to provide solutions and try to solve complex issues in the web hosting industry and give appropriate solutions to client’s needs. We understand their requirements, and suggests proper solutions.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-6 col-md-6 col-xl-4">
                        <div className="card service-card-item shadow-sm rounded-3 h-100 sal-animate" data-sal="slide-up" data-sal-duration="450" data-sal-delay="150" data-sal-easing="ease-in-out-sine">
                            <div className="card-body px-md-7 py-md-8">
                                <h6>Our Mission</h6>
                                <div className="d-flex gap-5 flex-wrap flex-sm-nowrap mt-6">
                                    <div>
                                        <img src="images/service-icon-2.png" alt="" />
                                    </div>
                                    <div>
                                        <p>Our mission is to provide reliable and secure hosting services that are easy to use, affordable, and have exceptional customer support. We provide innovative technology & experienced professional support.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-12 col-xl-4">
                        <div className="card service-card-item shadow-sm rounded-3 h-100 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="200" data-sal-easing="ease-in-out-sine">
                            <div className="card-body px-md-7 py-md-8">
                                <h6>Our Vision</h6>
                                <div className="d-flex flex-wrap flex-sm-nowrap gap-5 mt-6">
                                    <div>
                                        <img src="images/service-icon-3.png" alt="" />
                                    </div>
                                    <div>
                                        <p>Our vision is to stand as a leading web-hosting company that provides the most trusted, scalable, & secure hosting solutions to individuals, businesses, and organisations across the globe.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                </div>
            </div>
    </section>
    
    <section className="bg-dark pt-100 pb-120">
        <div className="pb-40">
            <div className="container">
                <div className="row g-4 justify-content-between align-items-center">
                    <div className="col-xxl-7 col-xl-7 col-lg-8">
                        <span className="section-title-dark style-bg fadeInUp">Our Clients</span>
                        <h2 className="text-white mb-3">Powerful Together, Booming Forever!</h2>
                        <p className="text-white mb-0 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">Our partnerships are built on reliability, trust, and a mutual vision for business success. With the help of seamless GPU dedicated server solutions and 24/7 support, we help harness new possibilities for your growth—because your success is our first priority.</p>
                    </div>
                </div>
            </div>
        </div>
        <div className="container">
            <div className="row">
                <SponserSlider />
            </div>
        </div>
    </section>

    <section className="pt-100 pb-100">
        <div className="container">
            <div className="cta-wrapper-one pt-60 pb-60 px-6 rounded-3">
                <div className="row justify-content-center">
                    <div className="col-xxl-7 col-xl-9">
                        <div className="d-flex justify-content-center" data-sal="slide-up" data-sal-duration="500"
                            data-sal-delay="200" data-sal-easing="ease-in-out-sine">
                                <span className="section-title style-bg fadeInUp">Solution</span>
                        </div>
                        <div className="text-center">
                            <h2 className="mb-5 h4" data-sal="slide-up" data-sal-duration="500" data-sal-delay="200"
                                data-sal-easing="ease-in-out-sine">Are you ready to host your website?</h2>
                            <p className="mb-8" data-sal="slide-up" data-sal-duration="500" data-sal-delay="200"
                                data-sal-easing="ease-in-out-sine">Begin your journey with India’s most reliable web hosting provider now! <br /> Connect with our expert instantly for call or chat support and host your favorite server now.</p>
                        </div>
                        <div className="d-flex align-items-center justify-content-center gap-4 flex-wrap flex-md-nowrap"
                            data-sal="slide-up" data-sal-duration="500" data-sal-delay="200"
                            data-sal-easing="ease-in-out-sine">
                            <Link to="tel:7737300013" className="btn btn-primary btn-arrow btn-lg fs-14 fw-medium rounded btn-height">
                                <span className="btn-arrow__text">
                                      +91-7737300013
                                    <span className="btn-arrow__icon">
                                        <i className="fa-solid fa-arrow-right"></i>
                                    </span>
                                </span>
                            </Link>
                            <Link to="#" className="btn btn-dark btn-arrow btn-lg fs-14 fw-medium rounded open-live-chat btn-height">
                                <span className="btn-arrow__text">
                                    Talk To An Expert
                                    <span className="btn-arrow__icon">
                                        <i className="fa-solid fa-arrow-right"></i>
                                    </span>
                                </span>
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>

    </>
  );
}

export default About;
